/*
 * Decléor — Text protection
 * ---------------------------------------------------------------------------
 * Product page → "Disable text selection and copy". The CSS half, in the
 * section's own style block, is what makes the text unselectable; this only
 * closes ⌘/Ctrl+A → ⌘/Ctrl+C, which Firefox copies out of a `user-select:
 * none` subtree anyway. Form fields keep their native clipboard.
 * A deterrent, not a lock: the text ships in the page source regardless.
 */
(function () {
  'use strict';

  var FIELDS =
    'input, textarea, select, [contenteditable]:not([contenteditable="false"])';

  // Resolved per event, not cached: the theme editor swaps the whole
  // #shopify-section-… wrapper every time a setting changes.
  function guardedSection() {
    var tag = document.querySelector('script[data-dc-text-protect]');
    if (!tag) {
      return null;
    }
    return document.getElementById(
      'shopify-section-' + tag.getAttribute('data-dc-text-protect')
    );
  }

  function inField(node) {
    var el = node.nodeType === 1 ? node : node.parentElement;
    if (!el) {
      return false;
    }
    if (!el.closest) {
      return false;
    }
    return el.closest(FIELDS) !== null;
  }

  function block(event) {
    var root = guardedSection();
    var selection = window.getSelection ? window.getSelection() : null;
    var range;
    if (root === null || selection === null || inField(event.target)) {
      return;
    }
    if (selection.rangeCount === 0) {
      return;
    }
    // intersectsNode, not contains: a select-all range starts on <body>,
    // outside the section, yet still sweeps its text into the clipboard.
    range = selection.getRangeAt(0);
    if (!range.intersectsNode) {
      return;
    }
    if (range.intersectsNode(root)) {
      event.preventDefault();
    }
  }

  document.addEventListener('copy', block);
  document.addEventListener('cut', block);
})();
